/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/date/datepb.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Pipe } from '@angular/core';
import * as i0 from "@angular/core";
/**
 * @param {?} value
 * @return {?}
 */
export function fromDate(value) {
    return {
        year: value.getFullYear(),
        month: value.getMonth() + 1,
        day: value.getDate(),
    };
}
/**
 * @param {?} value
 * @return {?}
 */
export function toDate(value) {
    return new Date(value.year, value.month - 1, value.day);
}
/*
 * Converts an ApiDate (datepb) to a JS Date object
 * Usage:
 *   value | datepb
 * Example:
 *   {{ record.date | datepb }}
 *   formats to: Date(2011, 2, 12)
 */
export class DatePbPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) { return toDate(value); }
}
DatePbPipe.decorators = [
    { type: Pipe, args: [{ name: 'datepb' },] },
];
/** @nocollapse */ DatePbPipe.ɵfac = function DatePbPipe_Factory(t) { return new (t || DatePbPipe)(); };
/** @nocollapse */ DatePbPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "datepb", type: DatePbPipe, pure: true });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DatePbPipe, [{
        type: Pipe,
        args: [{ name: 'datepb' }]
    }], null, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZXBiLnBpcGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9kYXRlL2RhdGVwYi5waXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLElBQUksRUFBZ0IsTUFBTSxlQUFlLENBQUM7Ozs7OztBQUlsRCxNQUFNLFVBQVUsUUFBUSxDQUFDLEtBQVc7SUFDbEMsT0FBTztRQUNMLElBQUksRUFBRyxLQUFLLENBQUMsV0FBVyxFQUFFO1FBQzFCLEtBQUssRUFBRyxLQUFLLENBQUMsUUFBUSxFQUFFLEdBQUcsQ0FBQztRQUM1QixHQUFHLEVBQUcsS0FBSyxDQUFDLE9BQU8sRUFBRTtLQUN0QixDQUFDO0FBQ0osQ0FBQzs7Ozs7QUFFRCxNQUFNLFVBQVUsTUFBTSxDQUFDLEtBQWM7SUFDbkMsT0FBTyxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxLQUFLLEdBQUcsQ0FBQyxFQUFFLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQTtBQUN6RCxDQUFDOzs7Ozs7Ozs7QUFXRCxNQUFNLE9BQU8sVUFBVTs7Ozs7SUFDckIsU0FBUyxDQUFDLEtBQWMsSUFBVSxPQUFPLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7OztZQUYxRCxJQUFJLFNBQUMsRUFBQyxJQUFJLEVBQUcsUUFBUSxFQUFDOztvRUFDVixVQUFVOzJEQUFWLFVBQVU7a0RBQVYsVUFBVTtjQUR0QixJQUFJO2VBQUMsRUFBQyxJQUFJLEVBQUcsUUFBUSxFQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtQaXBlLCBQaXBlVHJhbnNmb3JtfSBmcm9tICdAYW5ndWxhci9jb3JlJztcblxuaW1wb3J0IHtBcGlEYXRlfSBmcm9tIFwidmljcy92aXNpb25pY3MvYXBpL25nL2luZGV4XCI7XG5cbmV4cG9ydCBmdW5jdGlvbiBmcm9tRGF0ZSh2YWx1ZTogRGF0ZSk6IEFwaURhdGUge1xuICByZXR1cm4ge1xuICAgIHllYXIgOiB2YWx1ZS5nZXRGdWxsWWVhcigpLFxuICAgIG1vbnRoIDogdmFsdWUuZ2V0TW9udGgoKSArIDEsXG4gICAgZGF5IDogdmFsdWUuZ2V0RGF0ZSgpLFxuICB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gdG9EYXRlKHZhbHVlOiBBcGlEYXRlKTogRGF0ZSB7XG4gIHJldHVybiBuZXcgRGF0ZSh2YWx1ZS55ZWFyLCB2YWx1ZS5tb250aCAtIDEsIHZhbHVlLmRheSlcbn1cblxuLypcbiAqIENvbnZlcnRzIGFuIEFwaURhdGUgKGRhdGVwYikgdG8gYSBKUyBEYXRlIG9iamVjdFxuICogVXNhZ2U6XG4gKiAgIHZhbHVlIHwgZGF0ZXBiXG4gKiBFeGFtcGxlOlxuICogICB7eyByZWNvcmQuZGF0ZSB8IGRhdGVwYiB9fVxuICogICBmb3JtYXRzIHRvOiBEYXRlKDIwMTEsIDIsIDEyKVxuICovXG5AUGlwZSh7bmFtZSA6ICdkYXRlcGInfSlcbmV4cG9ydCBjbGFzcyBEYXRlUGJQaXBlIGltcGxlbWVudHMgUGlwZVRyYW5zZm9ybSB7XG4gIHRyYW5zZm9ybSh2YWx1ZTogQXBpRGF0ZSk6IERhdGUgeyByZXR1cm4gdG9EYXRlKHZhbHVlKTsgfVxufVxuIl19